// Librairies
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// Interfaces
export interface FieldInfo {
  label: string;
  hint: string;       // empty for a field outside the glossary
  path: string;       // the technical name, e.g. payload.criticity
}

// A key made readable: concreteWeight, battery_volt → "Concrete weight", "Battery volt".
export function humanizeField(key: string): string {
  const words = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_.-]+/g, ' ').trim().toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function fieldInfo(translate: TranslateService, collection: string, path: string): FieldInfo {
  const last = path.split('.').pop() ?? path;

  for (const key of [`fields.${collection}.${path}`, `fields.common.${last}`]) {
    const entry = translate.instant(key);

    if (typeof entry?.label === 'string') 
      return { label: entry.label, hint: entry.hint ?? '', path };
  }
  
  return { label: humanizeField(last), hint: '', path };
}

// {{ field.name | fieldInfo: widget.category }} → { label, hint, path }; pure: computed once per field.
@Pipe({
  name: 'fieldInfo',
  standalone: true
})

export class FieldInfoPipe implements PipeTransform {
  // Services
  private readonly translate: TranslateService = inject(TranslateService);

  transform(path: string | null | undefined, collection: string | null | undefined = 'metric'): FieldInfo {
    return fieldInfo(this.translate, (collection || 'metric').toLowerCase(), path ?? '');
  }
}
